import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import moment from 'moment';

class Incident extends React.Component {
  render() {
    const incident = this.props.incident;
    const previewing = this.props.client_incidents.selected_incident == incident._id ? true : false;

    let damageLevelColor;

    switch(incident.damage_level) {
      case 'Light':
        damageLevelColor = 'green'
        break;
      case 'Moderate':
        damageLevelColor = 'orange'
        break;
      case 'Severe':
        damageLevelColor = 'red';
        break;
      default:
        damageLevelColor = '';
        break;
    }
    return <div onClick={e => {this.props.onClick(this.props.incident)}} className="job">
      <div className={`panel ${!previewing ? `panel-featured-left panel-featured-primary` : ''}`}>
        <div className={`panel-body${previewing ? ' bg-primary animated pulse' : ''}`}>
          <div className={`widget-summary widget-summary-sm`}>
            <div className="widget-summary-col">
                <h3 className="title">
                  { moment(incident.created_timestamp).fromNow() }
                </h3>
                <hr className="dotted short" />
                {typeof incident.storm === 'object' ? (
                  <ul className="list-unstyled">
                    <li>

                    </li>
                    <li>
                      <strong className="amount"><i className="fa fa-cloud"></i> { incident.storm ? incident.storm.properties.title : '' } </strong>
                    </li>
                    <li><strong className="amount"><i className="fa fa-calendar"></i> { incident.storm ? moment(incident.storm.storm_date).format('YYYY-MM-DD') : '' } </strong></li>
                  </ul>
                ) : ''}
            </div>
            <div className="widget-summary-col widget-summary-col-icon">
              <div className={`summary-icon bg-${previewing ? ' bg-primary' : ' bg-primary'}`}><i className={`fa fa-bolt`}></i></div>
              <ul className="list-unstyled list">
                <li>
                  <strong>Damage Level </strong> <span className={`font-color ${damageLevelColor}`}> { incident.damage_level }</span>
                </li>
                <li>
                  <strong>Last Touched<br /></strong> <span> { moment(incident.updated_timestamp).fromNow() }  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

Incident.propTypes = {
  onClick: PropTypes.func,
  incident: PropTypes.object
}

const mapStateToProps = ({ client_incidents }) => ({ client_incidents });

export default connect(mapStateToProps, Actions)(Incident);



// WEBPACK FOOTER //
// ./src/browser/components/client/incidents/incident.js